class PhotoInstance {
  constructor(resolution, jpegLink, webpLink) {
    this.resolution = resolution;
    this.jpegLink = jpegLink;
    this.webpLink = webpLink;
  }

  jpegSource() {
    return `${this.jpegLink} ${this.resolution}w`;
  }

  webpSource() {
    return `${this.webpLink} ${this.resolution}w`;
  }

  static load(resolution, data) {
    return new PhotoInstance(parseInt(resolution, 10), data.jpeg, data.webp);
  }
}

export default class Photo {
  constructor(fileId, albumId, instances) {
    this.fileId = fileId;
    this.albumId = albumId;
    this.instances = instances;
  }

  jpegSrcSet() {
    return this.instances.slice(1).map(i => i.jpegSource())
      .reduce((s1, s2) => `${s1}, ${s2}`, this.instances[0].jpegSource());
  }

  webpSrcSet() {
    return this.instances.slice(1).map(i => i.webpSource())
      .reduce((s1, s2) => `${s1}, ${s2}`, this.instances[0].webpSource());
  }

  defaultSrc() {
    return this.instances[this.instances.length - 1].jpegSource();
  }

  static load(data) {
    if (data == null) {
      return null;
    }

    const instances = Object.entries(data.links).map(([res, d]) => PhotoInstance.load(res, d));

    return new Photo(data.file_id, data.album_id,
      instances.sort((a, b) => {
        if (a.resolution > b.resolution) {
          return 1;
        } if (a.resolution < b.resolution) {
          return -1;
        }

        return 0;
      }));
  }
}
